import React from "react";
import Hero from "../../components/pages/ReportSubmitted/Hero/Hero";
import CaseStatus from "../../components/pages/ReportSubmitted/CaseStatus/CaseStatus";
import "./ReportSubmitted.css";

const ReportSubmitted = () => {
  return (
    <div className="report-submitted-page">
      <div className="report-submitted-page__grid-section">
        <Hero />
      </div>
      <CaseStatus />
    </div>
  );
};

export default ReportSubmitted;
